import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import theme from './theme/theme';
import AppRoutes from './routes/AppRoutes';
import ApiErrorNotifier from './components/common/ApiErrorNotifier';

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <AppRoutes />
        <ApiErrorNotifier />
      </BrowserRouter>
    </ThemeProvider>
  );
}
